import { render, staticRenderFns } from "./AdverseReaction.vue?vue&type=template&id=bd72a016"
import script from "./AdverseReaction.vue?vue&type=script&lang=js"
export * from "./AdverseReaction.vue?vue&type=script&lang=js"
import style0 from "./AdverseReaction.vue?vue&type=style&index=0&id=bd72a016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports